
import { Injectable } from '@angular/core';
import { CustomHttpClient, IRequestOptions } from './../../providers/CustomHttpClient';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../../model/user';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

 constructor(private http: CustomHttpClient) {
    
  } 
  
  login(Usuario: User) {
     return this.http.Post("api/authentication/Login", Usuario);
  }
  
  recuperaSenha(Usuario: User) {
     return this.http.Post("api/authentication/RecuperaSenha", Usuario);
  }
}
